import request from '@/utils/request'
import exp from 'constants'

// 创建代理产品
export const addAgentProduct = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/agent_product',
    method: 'post',
    data
})

// 删除代理产品
export const delAgentProduct = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/agent_product/' + params.id,
    method: 'delete'
})

// 编辑代理产品
export const setAgentProduct = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/agent_product/' + data.id,
    method: 'patch',
    data
})

// 获取代理产品列表
export const getAgentProductList = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/agent_product',
    method: 'get',
    params
})

// 获取代理产品详情
export const getAgentProductInfo = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/agent_product/' + params.id,
    method: 'get'
})

// 下级商户统计
export const getMerchantStatistical = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/descendants/statistics',
    method: 'get',
    params
})

// 下级代理
export const getSubordinateAgencyList = (params: any) => request({
    url: 'manage/agents/' + params.merchant_no,
    method: 'get',
    params: params.body
})